import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { Search, BookOpen } from "lucide-react";
import { useApi } from "../../lib/api";
import { Stagger } from "../../components/motion";
import { PageHeader, SkeletonGrid, EmptyState, ErrorState } from "../../components/common";
import CourseCard from "../../components/CourseCard";

const FILTERS = [["all", "Tümü"], ["in_progress", "Devam Eden"], ["completed", "Tamamlanan"]];

export default function Courses() {
  const { data, loading, error, reload } = useApi("/me/courses");
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  const list = useMemo(
    () => (data || []).filter((c) => (filter === "all" || c.state === filter) && c.title.toLocaleLowerCase("tr-TR").includes(q.toLocaleLowerCase("tr-TR"))),
    [data, filter, q]
  );
  return (
    <div>
      <PageHeader eyebrow="Öğrenme Alanım" title="Eğitimlerim" desc="Size atanmış tüm eğitim programları." />
      <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="inline-flex rounded-xl bg-white p-1 ring-1 ring-slate-200/80">
          {FILTERS.map(([k, label]) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`courses-filter-${k}`} className={`relative rounded-lg px-4 h-9 text-sm font-semibold transition-colors ${filter === k ? "text-white" : "text-slate-500 hover:text-[var(--ink)]"}`}>
              {filter === k && <motion.span layoutId="course-filter" className="absolute inset-0 rounded-lg bg-[var(--ink)]" transition={{ type: "spring", stiffness: 420, damping: 34 }} />}
              <span className="relative">{label}</span>
            </button>
          ))}
        </div>
        <div className="relative sm:w-72">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Eğitim ara..." className="field pl-9" data-testid="courses-search-input" />
        </div>
      </div>
      {error ? (
        <ErrorState message={error} onRetry={reload} />
      ) : loading ? (
        <SkeletonGrid count={3} className="h-80" />
      ) : list.length === 0 ? (
        <EmptyState icon={BookOpen} title="Bu kriterlere uygun eğitim bulunamadı." desc="Filtreyi değiştirerek tekrar deneyin." testid="courses-empty" />
      ) : (
        <Stagger key={filter + q} className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" gap={0.07}>
          {list.map((c) => <CourseCard key={c.id} c={c} />)}
        </Stagger>
      )}
    </div>
  );
}
